// extracted by mini-css-extract-plugin
export default {"reactionToggleButton":"ReactionButton-module__reactionToggleButton--axnvQ","reactionToggleButtonReacted":"ReactionButton-module__reactionToggleButtonReacted--TgLue"};